import { render } from "./Suppliers.vue?vue&type=template&id=03b08a7e&scoped=true&ts=true"
import script from "./Suppliers.vue?vue&type=script&lang=ts"
export * from "./Suppliers.vue?vue&type=script&lang=ts"

import "./Suppliers.vue?vue&type=style&index=0&id=03b08a7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b08a7e"]])

export default __exports__